<template>
  <el-select ref="notificationType" v-model="selected" filterable v-on:keyup.native.enter="enter" v-loading="loading"
    placeholder="Selecione  uma opção" @change="update()">
    <el-option v-for="row of notificationList" :key="row.id" :label="row.description" :value="row.id"></el-option>
  </el-select>
</template>

<script>
import { NotificationTemplateService } from "@/services/customers/template.services";
export default {
  name: "NotificationTemplateList",
  data: function () {
    return {
      notificationList: [],
      selected: "",
      loading: false,
    };
  },
  props: {
    current: String,
    userType: String,
  },
  watch: {
    current(newValue, oldValue) {
      this.selected = newValue;
    }
  },
  methods: {
    focus() {
      //this.$refs.notificationType.$el.getElementsByTagName('input')[0].focus();
    },
    enter() {
      this.$emit("enter");
    },
    fetch(query) {
      const vm = this;
      vm.loading = true;
      NotificationTemplateService.types()
        .then((response) => {
          setTimeout(() => {
            if (vm.userType !== '1' && vm.userType !== '3') {
              response.splice(response.findIndex(x => x.id === 'pdv'), 1);
              response.splice(response.findIndex(x => x.id === 'pdv.authorization'), 1);
            }
            vm.notificationList = response;
          }, 500)
        })
        .catch((error) => {
          this.$message({ type: "error", message: error });
        }).finally(() => vm.loading = false)
    },
    update() {
      const vm = this;
      vm.$emit("input", vm.selected);
      vm.$emit("selected", vm.selected);
    },
  },
  mounted() {
    const vm = this;
    vm.fetch();
  },
};
</script>